import { MlAccordion, MlAccordionItem } from './ml-accordion';
import { RenderRichText } from '@/components/helpers/cms/RenderRichText';
import { TMlAccordionCS } from './ml-accordion.types';

export const MlAccordionCS = ({ block }: TMlAccordionCS) => {
  if (!block) return null;

  const { items } = block;

  return (
    <MlAccordion>
      {items.map((item, index) => {
        const { title, body } = item.accordion_item;
        return (
          <MlAccordionItem key={index} index={index} title={title}>
            <RenderRichText body={body} />
          </MlAccordionItem>
        );
      })}
    </MlAccordion>
  );
};
